import PageBasicTemplate from '../components/PageBasicTemplate';
import ContactSection from '../components/ContactSection';
export default function Contact() {
  return <PageBasicTemplate title="お問い合わせ" sub_title="構想の段階から、ご相談ください。AIの活用や開発、運用の課題を一緒に整理します。"><div className="contact-layout"><div className="contact-side"><h2 style={{ marginTop: 20 }}>次の一歩を、<br />ともにつくる。</h2><p>AIエージェントの開発、AI／DXの推進、<br />プロダクトやインフラの構築。<br />実現したいことをお聞かせください。</p><p>いただいた内容を確認し、<br />担当者よりご連絡します。</p></div><ContactSection title="" /></div></PageBasicTemplate>;
}
